import React from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";

export default function TabRouter(props) {
  const { children, defaultTab, defaultPath, className } = props;

  var defaultTabRoute = React.Children.toArray(children).filter(
    (child) => child.props.label === defaultTab
  )[0];
  var defaultTabPath = defaultTabRoute.props.path;

  var tabs = React.Children.map(children, (child) => (
    <Tab
      value={child.props.path}
      label={child.props.label}
      component={Link}
      to={child.props.path}
    />
  ));

  return (
    <Router>
      <Route
        path={defaultPath}
        render={(history) => (
          <AppBar position="static">
            <Tabs
              value={
                history.location.pathname !== defaultPath
                  ? history.location.pathname
                  : defaultTabPath
              }
              className={className}
            >
              {tabs}
            </Tabs>
          </AppBar>
        )}
      />
      <Switch>
        <Route exact path={defaultPath}>
          {defaultTabRoute.props.children}
        </Route>
        {children}
      </Switch>
    </Router>
  );
}
